import React, { useState } from "react";
import { Typography, Row, Col, Progress } from "antd";
import "./IndustryDensity.css";

const IndustryDensity = ({data}) => {
  const { Text } = Typography;

  // const [densityData, setDensityData] = useState(props.data);

  const generateRandomColors = () => {
    let temp = [];
    data.map((i) => {
      let temp2 = [
        Math.floor(Math.random() * 256),
        100 + Math.floor(Math.random() * 256),
        50 + Math.floor(Math.random() * 256),
      ];
      temp = [...temp, temp2];
    });
    return temp;
  };
  const [colorCodes, setColorCodes] = useState(() => generateRandomColors());

  if(colorCodes?.length > 0){
  return data.map((item, index) => {
    return (
      <Row key={index} className="industryprogressContainer" style={{border:`2px solid rgb(${colorCodes[index][0]},${
        colorCodes[index][1]
      },${colorCodes[index][2]}`}}>
        
        <Progress
          percent={item.IndustryPercent}
          strokeColor={`rgba(${colorCodes[index][0]},${
            colorCodes[index][1]
          },${colorCodes[index][2]},0.8)`}
          trailColor={`rgba(${colorCodes[index][0]},${
            colorCodes[index][1]
          },${colorCodes[index][2]},0.4)`}
          strokeWidth={"50px"}
          strokeLinecap="square"
          showInfo={false}
        />
        <Row className="progressLabels">
          <div className="labelText">{item.IndustryName}</div>
          <div className="labelText">{item.Percentage} %</div>
        </Row>
      </Row>
    );
  });
}else if(colorCodes?.length > 1){
  return data.map((item, index) => {
    return (
      <Row key={index} className="industryprogressContainer" style={{border:`2px solid rgb(10,110
      },232`}}>
        
        <Progress
          percent={item.IndustryPercent}
          strokeColor={`rgba(10,110
          },232,0.8)`}
          trailColor={`rgba(10,${
            colorCodes[index][1]
          },232,0.4)`}
          strokeWidth={"50px"}
          strokeLinecap="square"
          showInfo={false}
        />
        <Row className="progressLabels">
          <div className="labelText">{item.IndustryName}</div>
          <div className="labelText">{item.Percentage} %</div>
        </Row>
      </Row>
    );
  });
}
};
export default IndustryDensity;
